<template>
    <div class="breadcrumbs" v-if="routesFromUrl.length > 0">
        <div class="wrapper">
            <span class="link">
                <router-link :style="linkColor" :to="this.fullPath('/')">
                    <img
                        class="home-icon"
                        src="data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M10%2020v-6h4v6h5v-8h3L12%203L2%2012h3v8z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E"
                        alt="Home"
                    />
                </router-link>
            </span>
            <template v-for="(route, index) in routesFromUrl">
                <i
                    class="arrow"
                    :style="[
                        linkColor,
                        isRtlLanguageFunc($globalConstants.host.language_code, {
                            transform: 'rotate(225deg)',
                        }),
                    ]"
                    :key="index + '_link_url'"
                ></i>
                <span class="link" :key="index + '_link'">
                    <component
                        :is="disableLinks ? 'span' : 'router-link'"
                        :style="linkColor"
                        :to="route['url']"
                    >
                        {{ $t(route['title']) }}
                    </component>
                </span>
            </template>
        </div>
    </div>
</template>

<script>
import { helper, contentDirectionMixin } from '@/ghost-mixins';

export default {
    name: 'SEOContentBreadcrumb',
    props: {
        name: {
            type: String,
        },
        color: {
            type: String,
        },
        articleTitle: {
            type: String,
        },
        disableLinks: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [helper, contentDirectionMixin],
    computed: {
        linkColor() {
            return { color: `${this.color}` };
        },
        routesFromUrl() {
            let routes = [];
            const urlPaths = window.location.pathname.split('/');
            urlPaths.forEach((path, index) => {
                if (!path) return;
                if (path === this.$globalConstants.host.language_code) return;

                routes.push({
                    url:
                        index === urlPaths.length - 1
                            ? location.pathname
                            : this.fullPath('/' + path),
                    title:
                        index !== urlPaths.length - 1
                            ? this.makeTitle(path)
                            : this.articleTitle,
                });
            });
            return routes;
        },
    },
    methods: {
        makeTitle(slug) {
            const words = slug.split('-');
            for (let i = 0; i < words.length; i++) {
                let word = words[i];
                words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            }
            return words.join(' ');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
@import '@/sass/font-mixin';

.breadcrumbs {
    z-index: 1;
    width: 100%;
    padding: 6px 0;

    @include tablet {
        max-width: 1200px;
    }

    @include desktop {
        max-width: 1200px;
    }

    > .wrapper {
        max-width: 500px;
        width: 100%;

        @include tablet {
            max-width: 1200px;
        }

        @include desktop {
            max-width: 1200px;
        }

        > .link {
            padding-left: 5px;

            > a {
                color: black;
                @include font-roboto(16px, normal, 0.015em);
            }

            &:first-of-type {
                padding-left: 0;
            }

            &:last-of-type > a {
                text-decoration: none;
                opacity: 0.8;
                //pointer-events: none;
            }

            span {
                user-select: none;
            }
        }

        > .arrow {
            width: 0;
            height: 0;
            border: 4px solid transparent;
            border-top: 4px solid;
            border-right: 4px solid;
            margin: 5px;
            transform: rotate(45deg);
            position: relative;
            display: inline-block;
            vertical-align: middle;
            box-sizing: border-box;
            color: black;
        }
    }

    .home-icon {
        width: 20px;
        vertical-align: text-bottom;
    }
}
</style>
